import { W as WuiTag$1, d as defineCustomElement$1 } from './tag.js';

const WuiTag = WuiTag$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTag, defineCustomElement };

//# sourceMappingURL=wui-tag.js.map